<template>
  <v-layout wrap>
      <v-dialog
        v-model="picker"
        max-width="290"
      >
        <v-date-picker v-model="datePicker"></v-date-picker>
      </v-dialog>
        <v-flex
      sm4
      xs12
      class="text-sm-left text-xs-center"
    >
      <v-btn @click="prev()">
        <v-icon
          dark
          left
        >
          keyboard_arrow_left
        </v-icon>
        Prev
      </v-btn>
    </v-flex>
    <v-flex
      sm4
      xs12
      class="text-xs-center"
    ><h2>{{ monthAndYear }}</h2>
      </v-flex>
    <v-flex
      sm4
      xs12
      class="text-sm-right text-xs-center"
    >
      <v-btn @click="next()">
        Next
        <v-icon
          right
          dark
        >
          keyboard_arrow_right
        </v-icon>
      </v-btn>
    </v-flex>
    <v-flex xs12>
      <v-sheet height="2000">
        <v-calendar
          :weekdays="weekdays"
          ref="calendar"
          type="month"
          v-model="start"
          end="2020-01-01"
          color="primary"
        >
          <template v-slot:day="{ present, past, date, day }">
            <v-layout row align-center justify-center v-scroll>
              <v-flex xs12>
              <div class="day-body">
                <div v-for="scp in getSCPsForDate(date)" :key="scp.id">
                    <SCPCalendarItem :scp=scp v-on:scpChanged="scpChanged" v-on:updateDateOnSCP="updateDateOnSCP"></SCPCalendarItem>
                </div>
                <div v-if="getTotalForDate(date) > 0">
                  <v-divider></v-divider>
                  <v-flex grow xs12 class="text-xs-center bold caption">TOTAL: {{getTotalForDate(date)}}</v-flex>
                </div>
                <v-spacer></v-spacer>
                <v-layout row justify-center align-center>
                  <v-flex xs1 v-if='isSunday(date) === false'>
                    <v-icon color="primary" small @click="addButtonTapped(date)">add_circle</v-icon>
                  </v-flex>
                  <v-flex xs12 v-if='isSunday(date) === true'>
                    <span v-if='isSunday(date) === true'>NO FRUIT</span>
                  </v-flex>
                </v-layout>
              </div>
              </v-flex>
            </v-layout>
          </template>
        </v-calendar>
      </v-sheet>
    </v-flex>
  </v-layout>
</template>

<script>
import SCPCalendarItem from './SCPCalendarItem'
import axios from 'axios'
import moment from 'moment'
export default {
  components: {
    SCPCalendarItem
  },
  data: () => ({
    picker: false,
    datePicker: new Date().toISOString().substr(0, 10),
    weekdays: [1, 2, 3, 4, 5, 6, 0],
    currentSCP: {},
    start: moment().startOf('month').format('YYYY-MM-DD'),
    today: moment().startOf('month').format('YYYY-MM-DD'),
    scpsArray: [],
    scps: {
      '2019-01-10': [
        {
          clientcode: 'WCL',
          WorkOrder: {
            date: Date()
          }
        }
      ]
    }
  }),
  created () {
    if (this.$cookies.isKey('scpCalendarToday')) {
      this.today = this.$cookies.get('scpCalendarToday')
    }
    this.querySCPs()
  },
  computed: {
    monthAndYear () {
      return moment(this.today).format('MMM YYYY')
    }
  },
  watch: {
    datePicker (nv, ov) {
      console.log(JSON.stringify(nv, null, 2))
      this.currentSCP.WorkOrder.date = nv
      this.picker = false
      axios
        .put(process.env.VUE_APP_BACKEND+'workorders/'+this.currentSCP.WorkOrder.id, this.currentSCP.WorkOrder)
        .then((response) => {
          this.scpChanged(this.currentSCP)
        }
        )
    }
  },
  methods: {
    updateDateOnSCP (scp) {
      this.currentSCP = scp
      this.datePicker = moment(scp.WorkOrder.date).format('YYYY-MM-DD')
      this.picker = true
    },
    onScroll (e) {
      // this.offsetTop = e.target.scrollTop
    },
    acceptFruit (date) {

    },
    isSunday (date) {
      return (moment(date).weekday() === 0)
    },
    addButtonTapped (date) {
      this.$router.push({
        path: '/workorder/-1',
        query: {
          type: 'SCP',
          lock: true,
          date: date
        }
      })
    },
    querySCPs () {
      this.start = moment(this.today).format('YYYY-MM-DD')
      var endDate = moment(this.today).add(1, 'month').format('YYYY-MM-DD')
      var url = process.env.VUE_APP_BACKEND+'scps?startDate='+moment(this.today).format('YYYY-MM-DD')+'&endDate='+endDate
      axios
        .get(url)
        .then(response => {
          this.scpsArray = response.data.data
          this.updateSCPDictionary()
        })
    },
    updateSCPDictionary () {
      this.scps = {}
      this.scpsArray.forEach(scp => {
        // the date comes in with a time of 00 which causes moment to convert it to the previous day so I add 7 hours to prevent this
        var dateString = moment(scp.WorkOrder.date).add(7, 'hours').format('YYYY-MM-DD')
        if (scp.WorkOrder.Client.CODE === 'CIN') {
          console.log(JSON.stringify(scp.WorkOrder.Client.CODE, null, 2))
        }
        if (!this.scps[dateString]) {
          this.scps[dateString] = []
        }
        this.scps[dateString].push(scp)
      })
    },
    scpChanged (scp) {
      for (var i=0; i<this.scpsArray.length; i++) {
        if (this.scpsArray[i].id === scp.id) {
          this.scpsArray[i].WorkOrder.date = scp.WorkOrder.date
        }
      }
      this.updateSCPDictionary()
    },
    getTotalForDate (date) {
      var scps = this.getSCPsForDate(date)
      var total = 0
      scps.forEach(scp => {
        total += scp.estimatedTons
      })
      return total.toFixed(1)
    },
    getSCPsForDate (date) {
      if (this.scps[date]) {
        return this.scps[date]
      } else {
        return []
      }
    },
    next () {
      this.$refs.calendar.next()
      this.today = moment(this.today).add(1, 'month')
      this.$cookies.set('scpCalendarToday', moment(this.today).format('YYYY-MM-DD'))
      this.querySCPs()
    },
    prev () {
      this.$refs.calendar.prev()
      this.today = moment(this.today).subtract(1, 'month')
      this.$cookies.set('scpCalendarToday', moment(this.today).format('YYYY-MM-DD'))
      this.querySCPs()
    }
  }
}
</script>
<style>
 .my-event {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    background-color: #1867c0;
    color: #ffffff;
    border: 1px solid #1867c0;
    width: 100%;
    font-size: 12px;
    padding: 3px;
    cursor: pointer;
    margin-bottom: 1px;
  }
</style>
